// extracted by mini-css-extract-plugin
export default {"dashboard-team-members":"style_dashboard-team-members__DkXFJ","team-members-header-container":"style_team-members-header-container__DIbPV"};